import { useState } from 'react'
import moment from 'moment'
import { useToast } from 'components/Shared/AppToast/ToastProvider'
import { useTranslation } from 'react-i18next'
import { BACKHAUL_ATTRIBUTION_MODELS } from 'api/backhaulAttribution'
import { updateBackhaulAttributionForPackage } from 'api/backhaulAttribution'

export const useEvaluationModal = ({ packageId, onEvaluationUpdated, onClose } = {}) => {
  const [isLoading, setIsLoading] = useState(false)
  const { addNotification } = useToast()
  const { t } = useTranslation()

  const options = [
    {
      value: BACKHAUL_ATTRIBUTION_MODELS.ALL_PURCHASES,
      label: t('PackageBuilder.packageBuilderResults.evaluationModal.modelType.allPurchases'),
    },
    {
      value: BACKHAUL_ATTRIBUTION_MODELS.EVENTS_FROM_PACKAGE,
      label: t('PackageBuilder.packageBuilderResults.evaluationModal.modelType.eventsFromPackage'),
    },
    {
      value: BACKHAUL_ATTRIBUTION_MODELS.EVENT_SERIES,
      label: t('PackageBuilder.packageBuilderResults.evaluationModal.modelType.eventSeries'),
    },
  ]

  const handleSubmit = async ({ date, attributionWindow, model }) => {
    if (!packageId || !date || !attributionWindow || !model || Number(attributionWindow) < 1) {
      return
    }

    setIsLoading(true)

    const emailSendDate = moment(date).format('YYYY-MM-DD')

    const res = await updateBackhaulAttributionForPackage(packageId, {
      emailSendDate,
      attributionWindow: Number(attributionWindow),
      model,
    })

    if (res.success) {
      if (onEvaluationUpdated) {
        onEvaluationUpdated()
      }
      if (onClose) {
        onClose()
      }
    } else {
      addNotification({
        message: t('common.genericError'),
        description: t('common.errors.inServerResponse'),
        variant: 'error',
      })
    }

    setIsLoading(false)
  }

  return {
    handleSubmit,
    isLoading,
    options,
  }
}